// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Sora:wght@400;500;600;700;800&family=Inter:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Simam Digital — WebXR Showcases shared brand stylesheet.
 * Source of truth for the design system: tokens + reusable components.
 * Imported by each showcase's styles/index.css and by the hub.
 *
 * Copyright (c) 2026 Simam Digital Ltd.
 */

:root {
	/* Brand palette (purple-forward) */
	--simam-purple: #7c3aed;
	--simam-purple-deep: #4c1d95;
	--simam-violet: #a855f7;
	--simam-violet-soft: #c4b5fd;

	/* Surfaces */
	--simam-ink: #0e0b1a;
	--simam-surface: #170f2e;
	--simam-surface-2: #1f1640;
	--simam-bg: radial-gradient(
			120% 120% at 80% -10%,
			rgba(124, 58, 237, 0.35) 0%,
			rgba(124, 58, 237, 0) 45%
		),
		radial-gradient(
			100% 100% at 0% 110%,
			rgba(168, 85, 247, 0.25) 0%,
			rgba(168, 85, 247, 0) 50%
		),
		linear-gradient(160deg, #1a1033 0%, #0e0b1a 70%);

	/* Text */
	--simam-text: #f5f3ff;
	--simam-text-muted: #b8a9d9;
	--simam-text-dim: #8b7fae;

	/* Lines & glass */
	--simam-border: rgba(196, 181, 253, 0.18);
	--simam-border-strong: rgba(196, 181, 253, 0.4);
	--simam-glass-bg: rgba(23, 15, 46, 0.6);
	--simam-glass-blur: 18px;

	/* Effects */
	--simam-glow: 0 0 0 1px rgba(168, 85, 247, 0.35),
		0 12px 40px rgba(124, 58, 237, 0.35);
	--simam-shadow: 0 18px 50px rgba(0, 0, 0, 0.45);

	/* Type */
	--simam-font-display: 'Sora', system-ui, sans-serif;
	--simam-font-body: 'Inter', system-ui, sans-serif;

	/* Brand accents (from simamdigital.com) */
	--simam-orange: #ff5a1f;
	--simam-orange-hover: #ff6f3c;
	--simam-green: #16b364;
	--simam-blue: #2d6bff;

	/* Clean dark surfaces (standardised, near-black) */
	--simam-black: #0a0b0f;
	--simam-panel: #14161d;
	--simam-panel-2: #1b1e27;
	--simam-line: rgba(255, 255, 255, 0.09);
	--simam-line-strong: rgba(255, 255, 255, 0.18);
	--simam-text-on-dark: #f4f5f7;
	--simam-text-muted-dark: #9aa1ad;

	/* Geometry */
	--simam-radius: 16px;
	--simam-radius-lg: 24px;
	--simam-radius-pill: 999px;
}

/* ---- Primitives ---------------------------------------------------------- */

.simam-glass {
	background: var(--simam-glass-bg);
	border: 1px solid var(--simam-border);
	border-radius: var(--simam-radius-lg);
	backdrop-filter: blur(var(--simam-glass-blur));
	-webkit-backdrop-filter: blur(var(--simam-glass-blur));
	box-shadow: var(--simam-shadow);
}

.simam-btn {
	font-family: var(--simam-font-display);
	font-weight: 600;
	font-size: 15px;
	letter-spacing: 0.01em;
	color: #fff;
	background: linear-gradient(
		135deg,
		var(--simam-purple) 0%,
		var(--simam-violet) 100%
	);
	border: none;
	border-radius: var(--simam-radius-pill);
	padding: 14px 26px;
	cursor: pointer;
	transition: transform 0.18s ease, box-shadow 0.18s ease, filter 0.18s ease;
	box-shadow: 0 8px 24px rgba(124, 58, 237, 0.4);
}

.simam-btn:hover {
	transform: translateY(-2px);
	box-shadow: 0 14px 36px rgba(168, 85, 247, 0.55);
	filter: brightness(1.06);
}

.simam-btn:active {
	transform: translateY(0);
}

.simam-btn--ghost {
	background: transparent;
	color: var(--simam-violet-soft);
	border: 1.5px solid var(--simam-border-strong);
	box-shadow: none;
}

.simam-btn--ghost:hover {
	background: rgba(168, 85, 247, 0.12);
	border-color: var(--simam-violet);
	color: #fff;
	box-shadow: 0 8px 24px rgba(124, 58, 237, 0.25);
}

/* Primary brand CTA (orange, flat — matches simamdigital.com) */
.simam-btn--accent {
	background: var(--simam-orange);
	box-shadow: none;
}

.simam-btn--accent:hover {
	background: var(--simam-orange-hover);
	box-shadow: 0 10px 28px rgba(255, 90, 31, 0.32);
	filter: none;
}

/* Shared footer used across showcases */
.simam-footer {
	font-family: var(--simam-font-body);
	font-size: 12.5px;
	line-height: 1.7;
	color: var(--simam-text-dim);
	display: flex;
	flex-direction: column;
	gap: 2px;
	margin-top: 22px;
}

.simam-footer a {
	color: var(--simam-text-muted);
	text-decoration: none;
	transition: color 0.15s ease;
}

.simam-footer a:hover {
	color: var(--simam-violet);
}

/* Subtle Simam wordmark */
.simam-wordmark {
	font-family: var(--simam-font-display);
	font-weight: 800;
	letter-spacing: -0.02em;
	color: var(--simam-text);
}

.simam-wordmark > span {
	background: linear-gradient(
		135deg,
		var(--simam-violet) 0%,
		var(--simam-violet-soft) 100%
	);
	-webkit-background-clip: text;
	background-clip: text;
	-webkit-text-fill-color: transparent;
}
`, "",{"version":3,"sources":["webpack://./../brand/simam-brand.css"],"names":[],"mappings":"AAAA;;;;;;EAME;;AAIF;CACC,mCAAmC;CACnC,uBAAuB;CACvB,4BAA4B;CAC5B,uBAAuB;CACvB,4BAA4B;;CAE5B,aAAa;CACb,oBAAoB;CACpB,wBAAwB;CACxB,0BAA0B;CAC1B;;;;;;;;;;kDAUiD;;CAEjD,SAAS;CACT,qBAAqB;CACrB,2BAA2B;CAC3B,yBAAyB;;CAEzB,kBAAkB;CAClB,yCAAyC;CACzC,+CAA+C;CAC/C,uCAAuC;CACvC,wBAAwB;;CAExB,YAAY;CACZ;sCACqC;CACrC,+CAA+C;;CAE/C,SAAS;CACT,mDAAmD;CACnD,iDAAiD;;CAEjD,0CAA0C;CAC1C,uBAAuB;CACvB,6BAA6B;CAC7B,sBAAsB;CACtB,qBAAqB;;CAErB,mDAAmD;CACnD,sBAAsB;CACtB,sBAAsB;CACtB,wBAAwB;CACxB,uCAAuC;CACvC,8CAA8C;CAC9C,6BAA6B;CAC7B,gCAAgC;;CAEhC,aAAa;CACb,oBAAoB;CACpB,uBAAuB;CACvB,0BAA0B;AAC3B;;AAEA,+EAA+E;;AAE/E;CACC,iCAAiC;CACjC,qCAAqC;CACrC,qCAAqC;CACrC,8CAA8C;CAC9C,sDAAsD;CACtD,+BAA+B;AAChC;;AAEA;CACC,sCAAsC;CACtC,gBAAgB;CAChB,eAAe;CACf,sBAAsB;CACtB,WAAW;CACX;;;;EAIC;CACD,YAAY;CACZ,uCAAuC;CACvC,kBAAkB;CAClB,eAAe;CACf,0EAA0E;CAC1E,8CAA8C;AAC/C;;AAEA;CACC,2BAA2B;CAC3B,gDAAgD;CAChD,wBAAwB;AACzB;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,uBAAuB;CACvB,+BAA+B;CAC/B,8CAA8C;CAC9C,gBAAgB;AACjB;;AAEA;CACC,oCAAoC;CACpC,iCAAiC;CACjC,WAAW;CACX,+CAA+C;AAChD;;AAEA,gEAAgE;AAChE;CACC,+BAA+B;CAC/B,gBAAgB;AACjB;;AAEA;CACC,qCAAqC;CACrC,+CAA+C;CAC/C,YAAY;AACb;;AAEA,wCAAwC;AACxC;CACC,mCAAmC;CACnC,iBAAiB;CACjB,gBAAgB;CAChB,4BAA4B;CAC5B,aAAa;CACb,sBAAsB;CACtB,QAAQ;CACR,gBAAgB;AACjB;;AAEA;CACC,8BAA8B;CAC9B,qBAAqB;CACrB,4BAA4B;AAC7B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA,0BAA0B;AAC1B;CACC,sCAAsC;CACtC,gBAAgB;CAChB,uBAAuB;CACvB,wBAAwB;AACzB;;AAEA;CACC;;;;EAIC;CACD,6BAA6B;CAC7B,qBAAqB;CACrB,oCAAoC;AACrC","sourcesContent":["/*\n * Simam Digital — WebXR Showcases shared brand stylesheet.\n * Source of truth for the design system: tokens + reusable components.\n * Imported by each showcase's styles/index.css and by the hub.\n *\n * Copyright (c) 2026 Simam Digital Ltd.\n */\n\n@import url('https://fonts.googleapis.com/css2?family=Sora:wght@400;500;600;700;800&family=Inter:wght@300;400;500;600;700&display=swap');\n\n:root {\n\t/* Brand palette (purple-forward) */\n\t--simam-purple: #7c3aed;\n\t--simam-purple-deep: #4c1d95;\n\t--simam-violet: #a855f7;\n\t--simam-violet-soft: #c4b5fd;\n\n\t/* Surfaces */\n\t--simam-ink: #0e0b1a;\n\t--simam-surface: #170f2e;\n\t--simam-surface-2: #1f1640;\n\t--simam-bg: radial-gradient(\n\t\t\t120% 120% at 80% -10%,\n\t\t\trgba(124, 58, 237, 0.35) 0%,\n\t\t\trgba(124, 58, 237, 0) 45%\n\t\t),\n\t\tradial-gradient(\n\t\t\t100% 100% at 0% 110%,\n\t\t\trgba(168, 85, 247, 0.25) 0%,\n\t\t\trgba(168, 85, 247, 0) 50%\n\t\t),\n\t\tlinear-gradient(160deg, #1a1033 0%, #0e0b1a 70%);\n\n\t/* Text */\n\t--simam-text: #f5f3ff;\n\t--simam-text-muted: #b8a9d9;\n\t--simam-text-dim: #8b7fae;\n\n\t/* Lines & glass */\n\t--simam-border: rgba(196, 181, 253, 0.18);\n\t--simam-border-strong: rgba(196, 181, 253, 0.4);\n\t--simam-glass-bg: rgba(23, 15, 46, 0.6);\n\t--simam-glass-blur: 18px;\n\n\t/* Effects */\n\t--simam-glow: 0 0 0 1px rgba(168, 85, 247, 0.35),\n\t\t0 12px 40px rgba(124, 58, 237, 0.35);\n\t--simam-shadow: 0 18px 50px rgba(0, 0, 0, 0.45);\n\n\t/* Type */\n\t--simam-font-display: 'Sora', system-ui, sans-serif;\n\t--simam-font-body: 'Inter', system-ui, sans-serif;\n\n\t/* Brand accents (from simamdigital.com) */\n\t--simam-orange: #ff5a1f;\n\t--simam-orange-hover: #ff6f3c;\n\t--simam-green: #16b364;\n\t--simam-blue: #2d6bff;\n\n\t/* Clean dark surfaces (standardised, near-black) */\n\t--simam-black: #0a0b0f;\n\t--simam-panel: #14161d;\n\t--simam-panel-2: #1b1e27;\n\t--simam-line: rgba(255, 255, 255, 0.09);\n\t--simam-line-strong: rgba(255, 255, 255, 0.18);\n\t--simam-text-on-dark: #f4f5f7;\n\t--simam-text-muted-dark: #9aa1ad;\n\n\t/* Geometry */\n\t--simam-radius: 16px;\n\t--simam-radius-lg: 24px;\n\t--simam-radius-pill: 999px;\n}\n\n/* ---- Primitives ---------------------------------------------------------- */\n\n.simam-glass {\n\tbackground: var(--simam-glass-bg);\n\tborder: 1px solid var(--simam-border);\n\tborder-radius: var(--simam-radius-lg);\n\tbackdrop-filter: blur(var(--simam-glass-blur));\n\t-webkit-backdrop-filter: blur(var(--simam-glass-blur));\n\tbox-shadow: var(--simam-shadow);\n}\n\n.simam-btn {\n\tfont-family: var(--simam-font-display);\n\tfont-weight: 600;\n\tfont-size: 15px;\n\tletter-spacing: 0.01em;\n\tcolor: #fff;\n\tbackground: linear-gradient(\n\t\t135deg,\n\t\tvar(--simam-purple) 0%,\n\t\tvar(--simam-violet) 100%\n\t);\n\tborder: none;\n\tborder-radius: var(--simam-radius-pill);\n\tpadding: 14px 26px;\n\tcursor: pointer;\n\ttransition: transform 0.18s ease, box-shadow 0.18s ease, filter 0.18s ease;\n\tbox-shadow: 0 8px 24px rgba(124, 58, 237, 0.4);\n}\n\n.simam-btn:hover {\n\ttransform: translateY(-2px);\n\tbox-shadow: 0 14px 36px rgba(168, 85, 247, 0.55);\n\tfilter: brightness(1.06);\n}\n\n.simam-btn:active {\n\ttransform: translateY(0);\n}\n\n.simam-btn--ghost {\n\tbackground: transparent;\n\tcolor: var(--simam-violet-soft);\n\tborder: 1.5px solid var(--simam-border-strong);\n\tbox-shadow: none;\n}\n\n.simam-btn--ghost:hover {\n\tbackground: rgba(168, 85, 247, 0.12);\n\tborder-color: var(--simam-violet);\n\tcolor: #fff;\n\tbox-shadow: 0 8px 24px rgba(124, 58, 237, 0.25);\n}\n\n/* Primary brand CTA (orange, flat — matches simamdigital.com) */\n.simam-btn--accent {\n\tbackground: var(--simam-orange);\n\tbox-shadow: none;\n}\n\n.simam-btn--accent:hover {\n\tbackground: var(--simam-orange-hover);\n\tbox-shadow: 0 10px 28px rgba(255, 90, 31, 0.32);\n\tfilter: none;\n}\n\n/* Shared footer used across showcases */\n.simam-footer {\n\tfont-family: var(--simam-font-body);\n\tfont-size: 12.5px;\n\tline-height: 1.7;\n\tcolor: var(--simam-text-dim);\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 2px;\n\tmargin-top: 22px;\n}\n\n.simam-footer a {\n\tcolor: var(--simam-text-muted);\n\ttext-decoration: none;\n\ttransition: color 0.15s ease;\n}\n\n.simam-footer a:hover {\n\tcolor: var(--simam-violet);\n}\n\n/* Subtle Simam wordmark */\n.simam-wordmark {\n\tfont-family: var(--simam-font-display);\n\tfont-weight: 800;\n\tletter-spacing: -0.02em;\n\tcolor: var(--simam-text);\n}\n\n.simam-wordmark > span {\n\tbackground: linear-gradient(\n\t\t135deg,\n\t\tvar(--simam-violet) 0%,\n\t\tvar(--simam-violet-soft) 100%\n\t);\n\t-webkit-background-clip: text;\n\tbackground-clip: text;\n\t-webkit-text-fill-color: transparent;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
